import { FC } from 'react';
import SettingsHandler from '../Components/Settings/SettingsHandler';

export const PageSettings: FC = () => {
    return <SettingsHandler />;
};
